<template lang="pug">
div
    modal-payments(:payment='payment', :is-add='isModalAdd' :invoice='invoice',)
    vm-row.header(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
            div
                h4 {{ $t('strings.invoices') }}
            div(style="display:none;")
                vm-button(type="default" icon="list")
                vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
            div
                vm-button.separador-btn(icon="plus" @click="addInvoice" v-if="payments_store_permission && inOrder.status != 5") {{ $t('strings.add_invoice') }}
        vm-col(vm-sm=12)
            expanded.expanded.hand-cursor(v-for="(item, index) in invoices" :invoice="item" @edit-payment="editPayment" @delete-payment="deletePaymentConfirm" @add-payment="addPayment" @view-invoice="viewInvoice" @view-attachment-payment="openViewer" @view-attachment-invoice="openViewer" @edit-invoice="editInvoice" @delete-invoice="deleteInvoiceConfirm")
</template>
<script>
import ModalPayments from '@/components/in-order/ModalPayment.vue'
import Expanded from '@/components/in-order/Expanded.vue'
import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'Payments',
  components: {
    ModalPayments,
    Expanded,
    AccessDenied: () => import('@/components/aditionals/AccessDenied.vue')
  },
  data: () => ({
    payment: {},
    invoice: {},
    invoicesLocal: [],
    columnsInvoice: [
      'folio',
      'invoice_date',
      'amount',
      'balance'
    ],
    selected: [],
    isModalAdd: true,
    has_permission: true,
    payments_store_permission: true,
    payments_update_permission: true,
    customer: true,
    tab: 1
  }),
  async created () {
    this.$route.params.idFinisheds && await this.getInOrder()
    this.$route.params.id && await this.getInvoices()
    this.checkPermissionView('payments.index')
    this.invoicesLocal = this.invoices
    if (this.customer) {
      return this.invoicesLocal.filter(invoice => invoice.type === 1)
    } else {
      return this.invoicesLocal
    }
  },
  methods: {
    ...mapActions([
      'setModalPaymentVisible',
      'setModalInvoiceVisible',
      'deletePayment',
      'deleteInvoice',
      'approvedPayment',
      'setModalViewInvoiceVisible',
      'loadInOrder',
      'loadInvoices'
    ]),
    async getInOrder (page) {
      this.loadInOrder(this.$route.params.idFinisheds)
    },
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.payments_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'payments.store') > -1
      this.payments_update_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'payments.update') > -1
      this.customer = this.$auth.user().view_roles.findIndex(e => e === 'Customer') > -1
    },
    openViewer (attachment) {
      this.$viewer.show({
        urlFile: attachment.file_url,
        mime: attachment.mime_type,
        name: attachment.filename,
        color: '#FFF'
      })
    },
    addInvoice () {
      this.isModalAdd = true
      this.setModalInvoiceVisible(true)
      this.invoice = {
        invoice_date: moment().format('YYYY-MM-DD')
      }
    },
    editInvoice (invoice, index) {
      this.isModalAdd = false
      this.setModalInvoiceVisible(true)
      this.invoice = { ...invoice }
    },
    viewInvoice (invoice, index) {
      this.setModalViewInvoiceVisible(true)
      this.invoice = { ...invoice }
    },
    addPayment (invoice, index) {
      this.isModalAdd = true
      this.setModalPaymentVisible(true)
      this.payment = {
        invoice_id: invoice.id,
        type: 1,
        date_pay: moment().format('YYYY-MM-DD')
      }
      this.invoice = { ...invoice }
    },
    editPayment (payment, invoice) {
      this.isModalAdd = false
      this.setModalPaymentVisible(true)
      this.payment = { ...payment }
      this.invoice = { ...invoice }
    },
    async deletePaymentConfirm (payment) {
      let t = this
      this.auxDeletePayment = () => {
        t.deletePayment(payment)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('invoices.delete_payment_confirmation'),
        accept: this.auxDeletePayment
      })
    },
    async deleteInvoiceConfirm (invoice) {
      let t = this
      this.auxDeleteInvoice = () => {
        t.deleteInvoice(invoice)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('invoices.delete_invoice_confirmation'),
        accept: this.auxDeleteInvoice
      })
    },
    async getInvoices () {
      this.loadInvoices(this.$route.params)
    }
  },
  computed: {
    ...mapGetters([
      'inOrder',
      'invoices'
    ])
  },
  watch: {
    'invoices' (data) {
      this.invoicesLocal = data
      if (this.customer) {
        return this.invoicesLocal.filter(invoice => invoice.type === 1)
      } else {
        return this.invoicesLocal
      }
    }
  }
}
</script>
<style lang="scss">
.header {
    padding: 10px 20px;
}

.expand-user {
    width: 100% !important;
    display: block;
}

.separador-btn {
    margin: 10px 5px;
}

.filters {
    .filter {
        padding: 5px 10px;
        width: 250px;
    }
}

.con-vm-tooltip {
    display: inline-block;
    position: relative;
}

.vm-table--header {
    padding: 10px;

    span {
        width: 100%;

        .justify-content-between {
            div:last-child {
                .vm-button {
                    margin: 0 3px;
                }

                .vm-con-dropdown {
                    float: left;
                }

                .con-select {
                    display: inline-block;

                    input {
                        height: 32px;
                    }
                }
            }
        }
    }
}

.icon-btn {
    width: 30px;
    height: 30px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: rgb(231, 231, 231);
    }
}

.hand-cursor {
    cursor: pointer;
}</style>
